<template>
    <div id="userinfo">
        <transition name="scale">
            <div class="centerPanel">
                <div class="con">
                    <div class="full">
                        <div class="alert_title flex jb ac">
                            <p>个人资料</p>
                            <img src="./img/icon_img21.png" @click="close" class="close" />
                        </div>
                        <div class="avatar flex ac jc">
                            <el-upload class="avatar-uploader" :action="fileApi+'/api/front/upload/?storage=ali_oss'" :show-file-list="false" 
                            :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload" accept=".jpg,.png,.jpeg">
                                <div class="upload_wrap">
                                    <img :src="userInfo.avatarurl?userInfo.avatarurl:'/static/img/default-avatar.png'" class="pic" />
                                    <p class="text"><img src="./img/icon_img10.png" /> 修改头像</p>
                                </div>
                            </el-upload>

                           
                        </div>
                        <div class="info_list">
                            <div class="info_item flex jb ac">
                                <div class="title flex ac">
                                    <img src="./img/icon_img29.png" />
                                    <p>ID</p>
                                </div>
                                <div class="text">
                                    <p>{{userInfo.uid}}</p>
                                </div>
                            </div>
                            <div class="info_item flex jb ac">
                                <div class="title flex ac">
                                    <img src="./img/icon_img30.png" />
                                    <p>昵称</p>
                                </div>
                                <div class="text">
                                    <p>{{userInfo.nickname}}</p>
                                </div>
                            </div>
                            <div class="info_item flex jb ac">
                                <div class="title flex ac">
                                    <img src="./img/icon_img31.png" />
                                    <p>会员到期</p>
                                </div>
                                <div class="text ">
                                    <p class="c-fff">{{userInfo.vip_end_date}}</p>
                                </div>
                            </div>
                            <div class="info_item flex jb ac">
                                <div class="title flex ac">
                                    <img src="./img/icon_img30.png" />
                                    <p>我的邀请人</p>
                                </div>
                                <div class="text">
                                    <p>--</p>
                                </div>
                            </div>
                        </div>
                        <div class="info_list">
                            <div class="info_list_title">
                                <p>账号安全</p>
                            </div>
                            <div class="info_item flex jb ac">
                                <div class="title flex ac">
                                    <img src="./img/icon_img31.png" />
                                    <p>手机号：</p>
                                </div>
                                <div class="text">
                                    <p v-if="userInfo.phone">{{userInfo.phone}}</p>
                                    <span class="btn"
                                          v-else
                                          @click="bindphone">绑定手机</span>
                                </div>
                            </div>
                            <!-- <div class="info_item flex jb ac">
                                <div class="title flex ac">
                                    <img src="./img/icon_img30.png" />
                                    <p>微信号：</p>
                                </div>
                                <div class="text">
                                    <p class="c-fff">已绑定</p>
                                </div>
                            </div> -->
                        </div>
                    </div>
                </div>
            </div>
        </transition>

    </div>
</template>

<script>
export default {
    data () {
        return {
            fileApi:API_SERVER
        }
    },
    created () {

    },
    computed: {
        userInfo () {
            return this.$store.state.userInfo;
        }
    },
    methods: {
        fetchProfile(){
            this.$http.get(`/front/user/profile/`).then(res => {
                if (res.status == '200') {
                    this.$store.commit('setUserInfo', res.data)
                    this.$store.commit('setIsLogin', true)
                    this.$store.commit('setShowLogin', false)
                    localStorage.setItem("userinfo", JSON.stringify(res.data));
                    localStorage.setItem("invite_code", res.data.invite_code);
                }
            }).finally(() => {

            })
        },
        //上传头像
        handleAvatarSuccess(response, uploadFile) {
            let img_url = response.data.file_full_url
            this.userInfo.avatarurl = URL.createObjectURL(uploadFile.raw)
            this.$http.post(`/front/user/profile/avatar/`,{img_url:img_url}).then(res=>{
                this.fetchProfile()
            })
        },
        beforeAvatarUpload(rawFile) {
            if (rawFile.type !== 'image/jpeg' && rawFile.type !== 'image/png') {
                this.$message({
                    type: 'warning',
                    message: "请上传jpg或者png格式的图片",
                })
                return false
            } else if (rawFile.size / 1024 / 1024 > 2) {
                this.$message({
                    type: 'warning',
                    message: "请上传2M以内的图片",
                })
                return false
            }
            return true
        },
        //点击绑定手机
        bindphone () {
            this.$store.commit('setShowBindPhone', true)
        },
        //关闭绑定手机弹窗
        close () {
            this.$store.commit('setShowUserInfo', false)
        },
    },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
#userinfo {
    position: fixed;
    width: 100%;
    height: 100%;
    z-index: 1501;
    bottom: 0;
    left: 0;
    transition: all 0.3s;
    background: rgba(0, 0, 0, 0.8);
    overflow: auto;
    animation: fadeInSlowAni 0.3s 1;
    .centerPanel {
        position: fixed;
        z-index: 1501;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        transition: transform 0.2s;
        .con {
            width: 410px;
            height: 560px;
            padding: 20px;
            background-color: #1e1f22;
            border: 2px solid #5865f2;
            border-radius: 6px;
            .full {
                position: relative;
                display: flex;
                flex-direction: column;
                height: 100%;
                .alert_title {
                    p {
                        font-size: 14px;
                        color: #fff;
                    }
                    .close {
                        width: 16px;
                        height: 16px;
                        cursor: pointer;
                    }
                }
                .avatar {
                    flex-direction: column;
                    cursor: pointer;
                    .pic {
                        width: 70px;
                        height: 70px;
                        border-radius: 50%;
                        margin-bottom: 5px;
                        margin-top: 5px;
                    }
                    .text {
                        font-size: 14px;
                        color: #fff;
                        img {
                            width: 14px;
                            height: 14px;
                            display: inline-block;
                            margin-right: 5px;
                        }
                    }
                }
                .info_list {
                    padding: 15px 18px;
                    .info_list_title {
                        font-size: 14px;
                        color: #fff;
                        margin-left: -16px;
                    }
                    .info_item {
                        padding: 15px 0;
                        border-bottom: 1px solid #36373d;
                        .title {
                            img {
                                width: 16px;
                                height: 16px;
                                margin-right: 8px;
                            }
                            p {
                                font-size: 14px;
                                color: #b0b0b0;
                            }
                        }
                        .text {
                            font-size: 14px;
                            color: #b0b0b0;
                            .btn {
                                padding: 0 14px;
                                display: block;
                                line-height: 34px;
                                cursor: pointer;
                                background-color: #5865f2;
                                color: #fff;
                                border-radius: 4px;
                                &:hover {
                                    background-color: rgba(88, 101, 242, 0.867);
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}

.scale-enter-active,
.scale-leave-active {
    transition: all 0.3s;
}
.scale-enter,
.scale-leave-to {
    transform: translate(-50%, -50%) scale(0.6);
    opacity: 0;
}
</style>